import React from 'react'
import getCurrentCinemaWeeksArray from '../../functions/getCurrentCinemaWeeksArray'
import DashboardStats                 from './DashboardStats'
import DashboardCurrentMoviesPanel   from './DashboardCurrentMoviesPanel'
import DashboardFutureMoviesPanel    from './DashboardFutureMoviesPanel'
import DashboardNoPerformancesPanel  from './DashboardNoPerformancesPanel'
import DashboardIncompleteMoviesPanel from './DashboardIncompleteMoviesPanel'
import DashboardHexMenu              from './DashboardHexMenu'
import DashboardChangelog            from './DashboardChangelog'
import DashboardMoviesToday          from './DashboardMoviesToday'
import DashboardFooter               from './DashboardFooter'
import WrapperPageSimple from '../WrapperPage/present/WrapperPageSimple'
import config from '../../config.json'

class PageDashboard extends React.Component {
    componentDidMount() {
        this.props.onSetWeeks(getCurrentCinemaWeeksArray())
    }

    render() {
        const {
            currentWeek,
            currentMoviesCount, futureMoviesCount, noPerformancesCount,
            performancesCount, incompleteMovies, ignoredIncompleteMovies, version,
            currentMoviesList, noPerformancesMoviesList, nextWeekMovies, laterMovies,
            openPanel, onTogglePanel,
            routes, routeData, multiCinemaMode, hasNewsletter, hasChatbot, hasSocialMedia, history,
            changelogEntries, readVersions, onMarkRead, onMarkAllRead, cinemaProviderArr,
            theatres, todayPerformancesCount, todayMoviesCount, currentDate, currentDateTimestamp,
            openTheatres, onToggleTheatre,
            cinemaFilterOptions, selectedCinemaId, onSelectCinema,
            onIgnoreMovie, onUnignoreMovie,
        } = this.props

        return (
            <WrapperPageSimple addClassName="db-page" withoutTitle={true} pageTitleTransId={config.routes.dashboard.transId} pageTitle={config.routes.dashboard.name}>
                <div className="site-content">
                    <div className="db-dashboard">
                        <div className="db-dash">
                            <DashboardStats
                                currentWeek={currentWeek}
                                currentDate={currentDate}
                                currentMoviesCount={currentMoviesCount}
                                futureMoviesCount={futureMoviesCount}
                                noPerformancesCount={noPerformancesCount}
                                performancesCount={performancesCount}
                                incompleteMovies={incompleteMovies}
                                version={version}
                                openPanel={openPanel}
                                onTogglePanel={onTogglePanel}
                            />

                            {openPanel === 'currentMovies' && (
                                <DashboardCurrentMoviesPanel
                                    isOpen={true}
                                    movies={currentMoviesList || []}
                                    onClose={() => onTogglePanel('currentMovies')}
                                />
                            )}

                            {openPanel === 'future' && (
                                <DashboardFutureMoviesPanel
                                    isOpen={true}
                                    nextWeekMovies={nextWeekMovies || []}
                                    laterMovies={laterMovies || []}
                                    onClose={() => onTogglePanel('future')}
                                />
                            )}

                            {openPanel === 'noPerformances' && (
                                <DashboardNoPerformancesPanel
                                    isOpen={true}
                                    movies={noPerformancesMoviesList || []}
                                    onClose={() => onTogglePanel('noPerformances')}
                                />
                            )}

                            {openPanel === 'incompleteMovies' && (
                                <DashboardIncompleteMoviesPanel
                                    isOpen={true}
                                    movies={incompleteMovies || []}
                                    ignoredMovies={ignoredIncompleteMovies || []}
                                    onClose={() => onTogglePanel('incompleteMovies')}
                                    onIgnoreMovie={onIgnoreMovie}
                                    onUnignoreMovie={onUnignoreMovie}
                                />
                            )}

                            <div className="db-main-grid">
                                <DashboardHexMenu
                                    routes={routes || {}}
                                    routeData={routeData || {}}
                                    multiCinemaMode={multiCinemaMode}
                                    hasNewsletter={hasNewsletter}
                                    hasChatbot={hasChatbot}
                                    hasSocialMedia={hasSocialMedia}
                                    history={history}
                                />

                                <div className="db-dash-body">
                                    <DashboardChangelog
                                        entries={changelogEntries || []}
                                        readVersions={readVersions || []}
                                        onMarkRead={onMarkRead}
                                        onMarkAllRead={onMarkAllRead}
                                        cinemaProviderArr={cinemaProviderArr || []}
                                    />
                                </div>

                                <DashboardMoviesToday
                                    theatres={theatres || []}
                                    performancesCount={todayPerformancesCount || 0}
                                    moviesCount={todayMoviesCount || 0}
                                    currentDateTimestamp={currentDateTimestamp}
                                    openTheatres={openTheatres}
                                    onToggleTheatre={onToggleTheatre}
                                    cinemaFilterOptions={cinemaFilterOptions || []}
                                    selectedCinemaId={selectedCinemaId}
                                    onSelectCinema={onSelectCinema}
                                />
                            </div>

                        </div>
                        <DashboardFooter />
                    </div>
                </div>
            </WrapperPageSimple>
        )
    }
}

export default PageDashboard
